import { render } from "./FirstPageLink.vue?vue&type=template&id=30eb5eca"
import script from "./FirstPageLink.vue?vue&type=script&lang=js"
export * from "./FirstPageLink.vue?vue&type=script&lang=js"
script.render = render

export default script